import { useEffect, useState } from "react";
import { m, type Variants } from "framer-motion";
import {
  fetchSiteStats,
  formatLinksWrappedThisWeek,
  HERO_USAGE_FALLBACK,
} from "@/lib/site-stats";

/**
 * Homepage hero usage line. The design's "41,208 links wrapped this week"
 * was invented (web#62 / backend#251). This prints the live
 * `links_captured_7d` from GET /public/stats, and a no-number capability
 * sentence if that fetch fails.
 */
export default function HeroUsageBadge({ variants }: { variants?: Variants }) {
  const [label, setLabel] = useState(HERO_USAGE_FALLBACK);

  useEffect(() => {
    const ac = new AbortController();
    fetchSiteStats(ac.signal).then((stats) => {
      if (stats) setLabel(formatLinksWrappedThisWeek(stats.links_captured_7d));
    });
    return () => ac.abort();
  }, []);

  return (
    <m.p
      variants={variants}
      className="inline-flex items-center gap-[7px] rounded-2xl border border-ios-info/30 bg-ios-info/12 px-[13px] py-1.5 text-xs font-semibold text-ios-info"
    >
      <span aria-hidden="true">&#10022;</span>
      {label}
    </m.p>
  );
}
